(() => {
  'use strict';
  const source = document.currentScript || document.querySelector('script[data-gos-autumn-secrets]');
  if (!source || !('gosAutumnSecrets' in source.dataset)) return;
  const home = source.dataset.page === 'index';
  const assets = { open: source.dataset.peekOpen, closed: source.dataset.peekClosed, ghost: source.dataset.ghost };
  const locale = (source.dataset.locale || 'ru').toLowerCase();
  const lang = locale.startsWith('kk') ? 'kk' : locale.startsWith('en') ? 'en' : 'ru';
  const copy = {
    favorite: ['Эту забираем 👀', 'This one is yours 👀', 'Мынаны аламыз 👀'],
    hunt1: ['Лист 1 из 3. Найди ещё два на главной.', 'Leaf 1 of 3. Find two more on the home page.', '3 жапырақтың 1-і. Басты беттен тағы екеуін тап.'],
    hunt2: ['Лист 2 из 3. Остался ещё один.', 'Leaf 2 of 3. One to go.', '3 жапырақтың 2-сі. Біреуі қалды.'],
    hunt3: ['Осень пройдена. Стиль остался.', 'Autumn complete. Style remains.', 'Күз аяқталды. Стиль қалды.'],
    game: ['Осенний режим включён.', 'Autumn mode on.', 'Күзгі режим қосылды.'],
    peek: ['Я в домике.', 'Hood up.', 'Капюшондамын.'],
    ghost: ['Бу. Стиль на месте.', 'Boo. Still in style.', 'Бу. Стиль орнында.']
  };
  const t = key => copy[key][lang === 'kk' ? 2 : lang === 'en' ? 1 : 0];
  const leafSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20.5 2.5C12 3 5.9 5.4 3.6 10.6c-1.4 3.1-.1 6.5 2.9 7.6 3.7 1.3 8.8-1.1 11.6-5.3 2-2.9 2.9-6.8 2.4-10.4Z"/><path d="M3 21c4-5.1 8.5-8.9 14.4-12.4" fill="none" stroke="#242424" stroke-width="1.5"/></svg>';
  const ghostSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V10a8 8 0 0 1 16 0v10l-3-2-3 2-2-2-2 2-3-2-3 2Z" fill="#fff" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="11" r="1"/><circle cx="15" cy="11" r="1"/></svg>';
  const keys = { favorite: 'gos-autumn-secrets-v1:favorite', hunt: 'gos-autumn-secrets-v1:hunt' };
  const memory = Object.create(null);
  const pendingFavorites = new WeakMap();
  const features = new Map();
  let globalController = null;
  let toast = null;
  let toastTimer = 0;

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(navigator.connection?.saveData);
  }
  function read(key) {
    try { return window.sessionStorage.getItem(key) ?? memory[key] ?? null; }
    catch (_) { return memory[key] ?? null; }
  }
  function write(key, value) {
    memory[key] = value;
    try { window.sessionStorage.setItem(key, value); } catch (_) { /* Session memory remains available. */ }
  }
  function huntSet() {
    try { return new Set(JSON.parse(read(keys.hunt) || '[]').filter(id => ['promo', 'catalog', 'stores'].includes(id))); }
    catch (_) { return new Set(); }
  }
  function image(url, className, width, height) {
    const img = document.createElement('img');
    img.src = url;
    img.className = className;
    img.alt = '';
    img.loading = 'lazy';
    img.width = width;
    img.height = height;
    img.decoding = 'async';
    return img;
  }
  function clearToast() {
    window.clearTimeout(toastTimer);
    toast?.remove();
    toast = null;
  }
  function showToast(message, url, duration = 3000) {
    clearToast();
    toast = document.createElement('div');
    toast.className = 'gos-autumn-secrets__toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    if (url) toast.append(image(url, '', 42, 42));
    const words = document.createElement('span');
    words.textContent = message;
    toast.append(words);
    document.body.append(toast);
    toastTimer = window.setTimeout(clearToast, duration);
  }
  function announce(parent) {
    const status = document.createElement('span');
    status.className = 'gos-autumn-secrets__sr';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    parent.append(status);
    return status;
  }
  function ensure(name, node, setup) {
    const old = features.get(name);
    if (old?.node === node) return;
    if (old) { old.cleanup(); features.delete(name); }
    if (node) features.set(name, { node, cleanup: setup(node) });
  }
  function placeOver(target, base, button, grow = 0) {
    const rect = target.getBoundingClientRect();
    const host = base.getBoundingClientRect();
    const width = Math.max(44, rect.width + grow);
    const height = Math.max(44, rect.height + grow);
    button.style.left = `${rect.left - host.left + (rect.width - width) / 2}px`;
    button.style.top = `${rect.top - host.top + (rect.height - height) / 2}px`;
    button.style.width = `${width}px`;
    button.style.height = `${height}px`;
  }
  function geometry(button, callback, observed) {
    callback();
    const control = new AbortController();
    window.addEventListener('resize', callback, { passive: true, signal: control.signal });
    const observer = 'ResizeObserver' in window ? new ResizeObserver(callback) : null;
    if (observer && observed) observer.observe(observed);
    return () => { control.abort(); observer?.disconnect(); button.remove(); };
  }

  function onFavoriteCapture(event) {
    const target = event.target instanceof Element ? event.target.closest('[data-gos-save]') : null;
    if (!target || target.getAttribute('aria-pressed') !== 'false' || read(keys.favorite)) return;
    pendingFavorites.set(target, target.getAttribute('aria-pressed'));
  }
  function onFavoriteBubble(event) {
    const target = event.target instanceof Element ? event.target.closest('[data-gos-save]') : null;
    const before = target && pendingFavorites.get(target);
    if (!before) return;
    pendingFavorites.delete(target);
    // Shopping v3 updates aria-pressed in its document bubble listener. This
    // listener is registered later, so its microtask observes the final state.
    queueMicrotask(() => {
      if (before !== 'false' || target.getAttribute('aria-pressed') !== 'true' || read(keys.favorite)) return;
      write(keys.favorite, '1');
      showToast(t('favorite'), assets.open);
    });
  }

  function refreshHuntBadges() {
    const found = huntSet();
    document.querySelectorAll('[data-gos-secret-leaf]').forEach(button => {
      button.setAttribute('aria-pressed', String(found.has(button.dataset.gosSecretLeaf)));
      const badge = button.querySelector('.gos-autumn-secrets__leaf-count');
      if (badge) { badge.hidden = found.size === 0; badge.textContent = `${found.size}/3`; }
    });
  }
  function collectLeaf(id) {
    const found = huntSet();
    if (found.has(id)) return;
    found.add(id);
    write(keys.hunt, JSON.stringify([...found]));
    refreshHuntBadges();
    showToast(t(found.size === 3 ? 'hunt3' : found.size === 1 ? 'hunt1' : 'hunt2'), found.size === 3 ? assets.open : null, found.size === 3 ? 4000 : 3000);
  }
  function leafButton(id) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `gos-autumn-secrets__leaf gos-autumn-secrets__leaf--${id}`;
    button.dataset.gosSecretLeaf = id;
    button.setAttribute('aria-label', lang === 'en' ? `Find autumn leaf: ${id}` : lang === 'kk' ? `Күзгі жапырақты табу: ${id}` : `Найти осенний лист: ${id}`);
    button.innerHTML = `${leafSvg}<span class="gos-autumn-secrets__leaf-count" hidden></span>`;
    button.addEventListener('click', () => collectLeaf(id));
    return button;
  }

  function setupPromoLeaf(slide) {
    const art = slide.querySelector('.gos-campaign__art');
    if (!art) return () => {};
    const button = leafButton('promo');
    slide.append(button);
    const position = () => {
      const rect = art.getBoundingClientRect();
      const base = slide.getBoundingClientRect();
      button.style.left = `${rect.left - base.left + rect.width * .05}px`;
      button.style.top = `${rect.top - base.top + rect.height * .62}px`;
    };
    const stop = geometry(button, position, art);
    refreshHuntBadges();
    return stop;
  }
  function setupCatalogLeaf(heading) {
    const button = leafButton('catalog');
    heading.append(button);
    refreshHuntBadges();
    return () => button.remove();
  }
  function setupStoreLeaf(intro) {
    intro.dataset.gosSecretsStores = 'v1';
    const button = leafButton('stores');
    intro.append(button);
    refreshHuntBadges();
    return () => { button.remove(); delete intro.dataset.gosSecretsStores; };
  }

  function setupGame(slide) {
    const sticker = slide.querySelector('.gos-campaign__slide--promo .gos-campaign__sticker') || slide.querySelector('.gos-campaign__sticker');
    if (!sticker) return () => {};
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gos-autumn-secrets__hit';
    button.setAttribute('aria-label', lang === 'en' ? 'GAME ON: hold briefly or press Enter' : lang === 'kk' ? 'GAME ON: ұстап тұрыңыз немесе Enter басыңыз' : 'GAME ON: удерживайте или нажмите Enter');
    slide.append(button);
    const stopPosition = geometry(button, () => placeOver(sticker, slide, button), sticker);
    const control = new AbortController();
    const { signal } = control;
    let holdTimer = 0;
    let start = null;
    let last = -Infinity;
    const cancel = () => { window.clearTimeout(holdTimer); holdTimer = 0; start = null; };
    const reveal = () => {
      cancel();
      if (Date.now() - last < 3000) return;
      last = Date.now();
      showToast(t('game'), assets.closed);
    };
    button.addEventListener('pointerdown', event => {
      if (event.button !== 0 || event.isPrimary === false) return;
      cancel();
      start = { x: event.clientX, y: event.clientY };
      holdTimer = window.setTimeout(reveal, 700);
    }, { signal });
    button.addEventListener('pointermove', event => {
      if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10) cancel();
    }, { signal });
    for (const type of ['pointerup', 'pointercancel', 'pointerleave', 'blur']) button.addEventListener(type, cancel, { signal });
    button.addEventListener('click', event => { if (event.detail === 0) reveal(); }, { signal });
    return () => { cancel(); control.abort(); stopPosition(); };
  }

  function setupPeek(heading) {
    heading.dataset.gosSecretsHeading = 'v1';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gos-autumn-secrets__peek';
    button.setAttribute('aria-label', lang === 'en' ? 'Peek mascot: lift the hood' : lang === 'kk' ? 'Маскот: капюшонды көтеру' : 'Маскот: поднять капюшон');
    button.setAttribute('aria-pressed', 'false');
    const portrait = image(assets.open, '', 160, 160);
    button.append(portrait);
    heading.append(button);
    const status = announce(heading);
    const control = new AbortController();
    const { signal } = control;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    let hover = false, focus = false, toggled = false, manual = false, visible = true, frame = 0, noteTimer = 0, note = null;
    const setPortrait = () => {
      const next = (manual ? toggled : hover || focus) ? assets.closed : assets.open;
      if (portrait.getAttribute('src') !== next) portrait.src = next;
      button.setAttribute('aria-pressed', String(toggled));
    };
    const resetMotion = () => { button.style.setProperty('--peek-x', '0px'); button.style.setProperty('--peek-y', '0px'); button.style.setProperty('--peek-turn', '0deg'); };
    const tell = () => {
      note?.remove();
      note = document.createElement('span');
      note.className = 'gos-autumn-secrets__peek-note';
      note.textContent = t('peek');
      note.setAttribute('aria-hidden', 'true');
      heading.append(note);
      status.textContent = t('peek');
      window.clearTimeout(noteTimer);
      noteTimer = window.setTimeout(() => { note?.remove(); note = null; status.textContent = ''; }, 1800);
    };
    let point = null;
    heading.addEventListener('pointermove', event => {
      if (!fine.matches || !visible || reduced()) return;
      point = { x: event.clientX, y: event.clientY };
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const rect = button.getBoundingClientRect();
        const dx = point.x - (rect.left + rect.width / 2);
        const dy = point.y - (rect.top + rect.height / 2);
        if (Math.hypot(dx, dy) > 180) { resetMotion(); return; }
        button.style.setProperty('--peek-x', `${Math.max(-8, Math.min(8, dx / 16))}px`);
        button.style.setProperty('--peek-y', `${Math.max(-8, Math.min(8, dy / 16))}px`);
        button.style.setProperty('--peek-turn', `${Math.max(-4, Math.min(4, dx / 40))}deg`);
      });
    }, { passive: true, signal });
    heading.addEventListener('pointerleave', resetMotion, { signal });
    button.addEventListener('pointerenter', () => { if (fine.matches) { hover = true; setPortrait(); } }, { signal });
    button.addEventListener('pointerleave', () => { if (fine.matches) { hover = false; manual = false; toggled = false; setPortrait(); } }, { signal });
    button.addEventListener('focus', () => { focus = true; setPortrait(); }, { signal });
    button.addEventListener('blur', () => { focus = false; manual = false; toggled = false; setPortrait(); }, { signal });
    button.addEventListener('click', () => { manual = true; toggled = !toggled; setPortrait(); if (toggled) tell(); }, { signal });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting ?? false;
      if (!visible) { if (frame) window.cancelAnimationFrame(frame); frame = 0; resetMotion(); }
    }) : null;
    observer?.observe(heading);
    return () => {
      control.abort(); observer?.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      window.clearTimeout(noteTimer); note?.remove();
      status.remove(); button.remove(); delete heading.dataset.gosSecretsHeading;
    };
  }

  function setupGhost(slide) {
    const art = slide.querySelector('.gos-campaign__art--halloween');
    if (!art) return () => {};
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gos-autumn-secrets__ghost-hit';
    button.setAttribute('aria-label', lang === 'en' ? 'Reveal the sneaker ghost' : lang === 'kk' ? 'Кроссовка киген елесті көрсету' : 'Показать призрака в кроссовках');
    button.innerHTML = ghostSvg;
    slide.append(button);
    const position = () => {
      const rect = art.getBoundingClientRect(), base = slide.getBoundingClientRect();
      button.style.left = `${rect.right - base.left - 52}px`;
      button.style.top = `${rect.top - base.top + rect.height * .45}px`;
    };
    const stopPosition = geometry(button, position, art);
    const control = new AbortController();
    let timer = 0, last = -Infinity, spirit = null;
    button.addEventListener('click', () => {
      if (Date.now() - last < 3000) return;
      last = Date.now();
      spirit?.remove();
      spirit = image(assets.ghost, 'gos-autumn-secrets__ghost', 220, 220);
      if (reduced()) spirit.classList.add('is-static');
      spirit.setAttribute('aria-hidden', 'true');
      art.append(spirit);
      showToast(t('ghost'), null, 3000);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => { spirit?.remove(); spirit = null; }, 3000);
    }, { signal: control.signal });
    return () => { control.abort(); stopPosition(); window.clearTimeout(timer); spirit?.remove(); };
  }

  function initHome() {
    if (!home) return;
    const promo = document.querySelector('.gos-campaign__slide--promo');
    const catalog = document.querySelector('.gos-home__heading');
    const stores = document.querySelector('.gos-home-stores-v2 .gos-club__intro') || document.querySelector('.gos-club__intro');
    const halloween = document.querySelector('.gos-campaign__slide--halloween');
    ensure('huntPromo', promo, setupPromoLeaf);
    ensure('huntCatalog', catalog, setupCatalogLeaf);
    ensure('huntStores', stores, setupStoreLeaf);
    ensure('game', promo, setupGame);
    ensure('peek', catalog, setupPeek);
    ensure('ghost', halloween, setupGhost);
  }
  function cleanupAll() {
    globalController?.abort(); globalController = null;
    for (const feature of features.values()) feature.cleanup();
    features.clear();
    clearToast();
  }
  function boot() {
    if (globalController) return;
    globalController = new AbortController();
    const { signal } = globalController;
    document.addEventListener('click', onFavoriteCapture, { capture: true, signal });
    document.addEventListener('click', onFavoriteBubble, { signal });
    document.addEventListener('shopify:section:load', initHome, { signal });
    document.addEventListener('shopify:section:unload', event => {
      for (const [name, feature] of features) {
        if (event.target.contains(feature.node)) { feature.cleanup(); features.delete(name); }
      }
    }, { signal });
    initHome();
  }
  window.addEventListener('pagehide', cleanupAll);
  window.addEventListener('pageshow', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
